import { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap'
import { format, getDate } from 'date-fns'
import axios from 'axios'

function ConfirmPayrollSubmissionModal({ userId }) {
  const [open, setOpen] = useState(false)
  const [response, setResponse] = useState(null)
  const checkboxes = ['Yes', 'No']
  const today = new Date()
  const date = getDate(today)
  const monthYear = format(today, 'yyyy-MM')
  const handleCheckboxChange = (value) => {
    setResponse((prev) => (prev === value ? null : value))
  }

  const handleDone = async () => {
    if (!response) return

    try {
      await axios.post('payroll-submits', {
        userId,
        response,
        month: monthYear,
        date,
        submitDate: today
      })
    } catch (err) {
      console.error('Failed to submit payroll response', err)
    }

    setOpen(false)
  }

  const checkSubmissionStatus = async () => {
    try {
      const res = await axios.get('payroll-submits', {
        params: { userId, month: monthYear }
      })

      if (res.status != 200 || res.data.response === 'No') {
        setOpen(true)
      }
    } catch (err) {
      console.error('Failed to check submission status', err)
      setOpen(true)
    }
  }

  useEffect(() => {
    if (date >= 26 && date <= 30) {
      checkSubmissionStatus()
    }
  }, [date])

  return (
    <Modal isOpen={open} backdrop='static'>
      <ModalHeader>Add Payroll Submission Confirmation</ModalHeader>
      <ModalBody>
        <p className='mb-3'>Have you added the payroll submission this month?</p>
        <FormGroup className='d-flex '>
          {checkboxes.map((checkbox) => (
            <FormGroup check key={checkbox}>
              <Label check style={{ margin: '5px' }}>
                <Input type='checkbox' checked={response === checkbox} onChange={() => handleCheckboxChange(checkbox)} /> {checkbox}
              </Label>
            </FormGroup>
          ))}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={handleDone} disabled={!response}>
          Done
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmPayrollSubmissionModal
